import { useEffect } from 'react';

import { useQueryClient } from '@tanstack/react-query';

export const USER_META_UPDATED_STORAGE_KEY = 'rentify_user_meta_updated_at';

export const UserMetaCrossTabSync = () => {
  const queryClient = useQueryClient();

  useEffect(() => {
    const handleStorage = (event: StorageEvent) => {
      if (event.key !== USER_META_UPDATED_STORAGE_KEY) return;

      queryClient.invalidateQueries({ queryKey: ['user-meta'] });
    };

    window.addEventListener('storage', handleStorage);

    return () => {
      window.removeEventListener('storage', handleStorage);
    };
  }, [queryClient]);

  return null;
};
